@if (isLoggedIn$ | async) {
  @if (b2bUnit$ | async; as b2bUnits) {
    <div class="b2b-selector">
      <label for="b2b" class="b2b-selector-title">B2B Selector</label>
      <select id="b2b" class="b2b-selector-control" (change)="changeOrgUnit($event.target.value)">
        @for (item of b2bUnits; track item) {
          <option [value]="item.value" [selected]="item.selected">
            {{ item.label }}
          </option>
        }
      </select>
    </div>
  }
}
